import React from 'react';
import {SvgIcon} from '@mui/material';
import type {IconProps} from './types';

/** A two column layout where the right column fills the row. */
export const PanelRightIcon: React.FC<IconProps> = (props: IconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M3 4H21V20H3V4ZM5 6V18H19V6H5Z" />
      <path d="M12 7H18V17H12V7Z" />
    </SvgIcon>
  );
};
